import React, { useEffect, useState } from "react";
import {
  Label,
  Input,
  Button,
  Switch,
  RadioGroup,
  Radio,
  List,
  ListItem,
  makeStyles,
} from "@fluentui/react-components";
import Person from "../GenericComponent/Persona";
import SearchResourceInGraph from "../GenericComponent/SearchResourceInGraph";
import { Add20Filled, DeleteRegular, EditRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import InfoButton from "../GenericComponent/InfoButton";
import "../CSS/QueueForm.css";
const useStyles = makeStyles({
  vipList: {
    maxHeight: "200px", // hauteur fixe
    width: "35%", // largeur limitée
    marginLeft: "5rem", // décalage à gauche
    overflowY: "auto", // scroll si dépassement
    padding: 0,
  },
  vipItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 0",
  },

  vipActions: {
    display: "flex",
    alignItems: "center",
    gap: "4px", // small spacing only between edit and delete
  },
});

export default function VIPPriority(props) {
  const { t } = useTranslation();
  const styles = useStyles();
  const [showVipForm, setShowVipForm] = useState(false);
  const [vipType, setVipType] = useState("");
  const [vipName, setVipName] = useState("");
  const [vipPhone, setVipPhone] = useState("");
  const [selectedVipUser, setSelectedVipUser] = useState(null);
  const [editVipId, setEditVipId] = useState(null);

  const handleAddVipPhone = () => {
    if (!vipPhone || !vipName) return; // sécuriser

    props.setQueue({
      ...props.queue,
      vipIds: [...(props.queue.vipIds || []), vipPhone],
      vipDetails: {
        ...(props.queue.vipDetails || {}),
        [vipPhone]: {
          displayName: vipName,
          type: vipType, // "phone" ou "user"
        },
      },
    });

    // Reset inputs
    setVipName("");
    setVipPhone("");
    setShowVipForm(false);
  };
  const handleAddVipUser = () => {
    if (!selectedVipUser) return; // sécurité

    props.setQueue({
      ...props.queue,
      vipIds: [...(props.queue.vipIds || []), selectedVipUser.id],
      vipDetails: {
        ...(props.queue.vipDetails || {}),
        [selectedVipUser.id]: {
          displayName: selectedVipUser.displayName,
          type: "user",
        },
      },
    });
    setShowVipForm(false);
    setSelectedVipUser(null);
  };

  return (
    <div style={{marginLeft:'25%'}}>
      {" "}
      <div className="queue-form-checkbox-vip-priority">
        <Label weight="semibold">
          {t("VIP_PRIORITY")}
          <InfoButton infoKey="VIP_PRIORITY" category="QUEUES" />
        </Label>
        <Switch
          checked={props.queue.enableVipPriority || false}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(e, data) => {
            props.setQueue({
              ...props.queue,
              enableVipPriority: data.checked,
            });
          }}
        />
      </div>
      {showVipForm === false ? (
        <Button
          icon={<Add20Filled />}
          className="queue-form-btn-add-VIP"
          appearance="primary"
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onClick={() => setShowVipForm(true)}
        >
        
        </Button>
      ) : (
        <>
          <RadioGroup
            className="queue-form-radio-group"
            layout="horizontal"
            value={vipType}
            onChange={(_, data) => {
              setVipType(data.value);
            }}
          >
            <Radio value="phone" label={t("PHONE")} />
            <Radio value="user" label={t("USER")} />
          </RadioGroup>
          {vipType === "phone" && (
            <div className="queue-form-vip-form">
              <Input
                placeholder={t("VIP_NAME")}
                className="queue-form-input-inline"
                value={vipName}
                disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                onChange={(event, data) => setVipName(data.value)}
              />
              <Input
                type="number"
                placeholder={t("PHONE_NUMBER")}
                className="queue-form-input-inline queue-form-no-spinner"
                value={vipPhone}
                disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                onChange={(event, data) => setVipPhone(data.value)}
              />

              <Button
                icon={<Add20Filled />}
                className="queue-form-btn-add-VIP"
                appearance="primary"
                disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                onClick={handleAddVipPhone}
              >
              </Button>
            </div>
          )}
          {vipType === "user" && (
            <div className="queue-form-vip-form-user">
              <div className="queue-form-search-user">
                <SearchResourceInGraph
                  displayName={selectedVipUser?.displayName}
                  onSelectUser={(user) => setSelectedVipUser(user)}
                  disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                />
              </div>
              <Button
                icon={<Add20Filled />}
                className="queue-form-btn-add-VIP"
                appearance="primary"
                disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                onClick={handleAddVipUser}
              >
              </Button>
            </div>
          )}
        </>
      )}{" "}
      <List navigationMode="items" className={styles.vipList}>
        {(props.queue.vipIds||[]).map((id) => {
          const vip = props.queue.vipDetails[id];
          if (!vip) return null;

          return (
            <ListItem
              className={styles.vipItem}
              key={id}
              aria-label={`${vip.displayName}, ${vip.type}`}
            >
              <Person
                details={{ displayName: vip.displayName }}
                avatar={{ image: { src: vip.photo || "" } }} // photo si user
              />
              <div className={styles.vipActions}>
                <Button
                  appearance="subtle"
                  icon={<EditRegular />}
                  disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                  onClick={() => {
                    const vip = props.queue.vipDetails[id];

                    //  retirer immédiatement de la liste
                    const newVipIds = props.queue.vipIds.filter(
                      (v) => v !== id
                    );
                    const newVipDetails = { ...props.queue.vipDetails };
                    delete newVipDetails[id];

                    props.setQueue({
                      ...props.queue,
                      vipIds: newVipIds,
                      vipDetails: newVipDetails,
                    });

                    //  Ouvrir formulaire
                    setShowVipForm(true);

                    //  Enregistrer l'élément à modifier
                    setEditVipId(id);

                    //  Définir le type
                    setVipType(vip.type);

                    //  Remplir le formulaire selon type
                    if (vip.type === "phone") {
                      setVipName(vip.displayName);
                      setVipPhone(id); // id = phone number
                    } else if (vip.type === "user") {
                      setSelectedVipUser({
                        id,
                        displayName: vip.displayName,
                      });
                    }
                  }}
                />

                <Button
                  appearance="subtle"
                  icon={<DeleteRegular />}
                  disabled={!props.permissions?.canDelete}
                  onClick={() => {
                    // Supprimer de vipIds et vipDetails
                    const newVipIds = props.queue.vipIds.filter(
                      (v) => v !== id
                    );
                    const newVipDetails = { ...props.queue.vipDetails };
                    delete newVipDetails[id];

                    props.setQueue({
                      ...props.queue,
                      vipIds: newVipIds,
                      vipDetails: newVipDetails,
                    });
                  }}
                  aria-label={`Remove ${vip.displayName}`}
                />
              </div>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
